export { default } from './TabScrollButton';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/TabScrollButton/index.js
// module id = 597
// module chunks = 121